import { render, staticRenderFns } from "./customfields.vue?vue&type=template&id=09096cf7"
import script from "./customfields.vue?vue&type=script&lang=js"
export * from "./customfields.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports